// 各版本对应code
export const ECOLOGY_VERSION_CODE = 160 // 生态版
export const LATITUDE_VERSION_CODE = 142 // 纵横标准版
export const ENTERPRISE_VERSION_CODE = 1 // 企业版
export const PROFESSIONAL_VERSION_CODE = 2 // 专业版
export const SENIOR_VERSION_CODE = 7 // 高阶版

// 各版本对应枚举
export const ECOLOGY_VERSION = 'ECOLOGY' // 生态版
export const LATITUDE_VERSION = 'LATITUDE' // 纵横标准版
export const ENTERPRISE_VERSION = 'ENTERPRISE' // 企业版
export const PROFESSIONAL_VERSION = 'PROFESSIONAL' // 专业版
export const SENIOR_VERSION = 'SENIOR' // 高阶版

// 各版本对应文案
export const ECOLOGY_VERSION_TEXT = '生态版' // 生态版
export const LATITUDE_VERSION_TEXT = '纵横标准版' // 纵横标准版
export const ENTERPRISE_VERSION_TEXT = '企业版' // 企业版
export const PROFESSIONAL_VERSION_TEXT = '专业版' // 专业版
export const SENIOR_VERSION_TEXT = '高阶版' // 高阶版

export const SHOW_LOGO_VERSION_CODE_LIST = [ECOLOGY_VERSION_CODE, LATITUDE_VERSION_CODE] // 需要显示对应logo的版本列表
